<section>
  <header>
    <h4 class="t-bold" data-test-id="reimbursementCardHeader">
      {{ config.title }}
    </h4>
  </header>

  <form-group
    [configs]="config.controls"
    [form]="form"
    data-test-id="reimbursementCardForm"
  >
  </form-group>

  @if (isFormValid && employerReimbursement) {
    <section>
      @if (displayPaperFormLink) {
        <div class="message__container">
          <h6 class="t-bold" data-test-id="reimbursementCardMessage">
            Thank you for your interest in Cigna!
          </h6>
          <p data-test-id="reimbursementCardText">
            Based on your responses to the 2020 Qualified Small Employer Health
            Reimbursement Arrangement Questions, you are required to have your
            employer provide an affidavit.
            <br />
            <br />
            <a
              class="t-link t-bold"
              target="_blank"
              [href]="config.pdfDownloadLink"
              data-test-id="reimbursementPdfLink"
              >Click Here</a
            >
            to download and print the Colorado Application which includes the
            Employer Affidavit. Please mail the completed and signed application
            to Cigna as instructed on the form.
          </p>
        </div>
      } @else {
        <div class="message__container">
          <h6 class="t-bold" data-test-id="reimbursementNoFormHeader">
            Thank you for your interest in Cigna!
          </h6>
          <p data-test-id="reimbursementNoFormText">
            Based on your responses to the 2020 Qualified Small Employer Health
            Reimbursement Arrangement Questions, we are unable to issue an
            individual policy with the premiums, or portion thereof, paid or
            reimbursed by your employer. Please contact your broker or the
            Colorado Division of Insurance with any questions.
          </p>
        </div>
      }
    </section>
  }
</section>
